export const rmStorage = (key) => sessionStorage.removeItem(key)

export const getStorage = (key) => sessionStorage.getItem(key)

export const setStorage = (key, val) => sessionStorage.setItem(key, val)

export const clearStorage = () => sessionStorage.clear()